import { render, staticRenderFns } from "./articleListVertical.vue?vue&type=template&id=c64d7956&scoped=true&"
import script from "./articleListVertical.vue?vue&type=script&lang=js&"
export * from "./articleListVertical.vue?vue&type=script&lang=js&"
import style0 from "./articleListVertical.vue?vue&type=style&index=0&id=c64d7956&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c64d7956",
  null
  
)

export default component.exports